module.exports = __webpack_public_path__ + "static/media/sucursal-ico.88f1d700.svg";